import EditProductGroup from "./Edit";

export default function AddProductGroup() {
  return <EditProductGroup mode="add" />;
}

